import styled from "styled-components";

export const Container = styled.div<{ nivel: number }>`
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;
    padding-left: 0;
    margin-left: 0;
    position: relative;
`;


